import { StyleSheet } from '@react-pdf/renderer'

export const columnPdfStyles = StyleSheet.create({
  columnFixed: {
    width: '170px',
    justifyContent: 'center',
  },
  columnFluid: {
    flexGrow: 1,
    flexBasis: 0,
    justifyContent: 'center',
    alignItems: 'flex-end',
  },
})
